import './select-student-to-register.scss';
import registerStudentTemplate from '../register-student/register-student.html';
import template from './select-student-to-register.html';

export class SelectStudentToRegisterController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $state, $rootScope, StudentService
  ) {
    this.$rootScope = $rootScope;
    this.$log = $log;
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.StudentService = StudentService;
  }

  cancel() {
    this.$mdDialog.cancel();
  }

  selectStudent(student) {
    this.$mdDialog.show({
      resolve: {
        students: () => {
          return this.StudentService.getForRegistration({studentId: student.studentAssignedToCardOwner.scrStudentId}).then(response => {
            return response.data.students;
          }).catch(error => {
            this.$mdDialog.show(
              this.$mdDialog.extendError({
                locals: {error}
              })
            );
          });
        }
      },
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'RegisterStudentController',
      locals: {
        currentClassRoom: this.currentClassRoom,
        access: this.access,
        classRooms: this.classRooms
      },
      template: registerStudentTemplate,
      disableParentScroll: true,
      clickOutsideToClose: true
    }).then(() => {
      this.$rootScope.$broadcast('dashboard.config.studentIsRegistered');
    });
  }
}

export const SelectStudentToRegister = {
  bindings: {
    nextStep: '&',
    students: '=',
    cardId: '@',
    access: '=',
    currentClassRoom: '=',
    classRooms: '='
  },
  controller: SelectStudentToRegisterController,
  template
};
